import { render, staticRenderFns } from "./setRoleMenu.vue?vue&type=template&id=9ed32294"
import script from "./setRoleMenu.vue?vue&type=script&lang=js"
export * from "./setRoleMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports